import React from 'react';
import { WebinarLink } from './WebinarLink';
export const CallToAction = ({
  openModal
}) => {
  // Replace 'webinar' with WebinarLink component in text
  const replaceWebinarWithLink = text => {
    const parts = text.split(/(\bwebinar\b)/i);
    return parts.map((part, index) => {
      if (part.toLowerCase() === 'webinar') {
        return <WebinarLink key={index} onClick={openModal} data-id="element-49">
            webinar
          </WebinarLink>;
      }
      return part;
    });
  };
  return <section className="mb-10" data-id="element-50">
      <div className="w-full mb-6" data-id="element-51">
        <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/2FwYxJVjG6C7aeyL5JTuqC/Scherm_afbeelding_2025-08-15_om_15.56.55-min.png" alt="Vrouw communiceert met haar hond in een gezellige woonkamer" className="w-full h-auto rounded-lg shadow-md hover:opacity-95 transition-opacity cursor-pointer" onClick={openModal} data-id="element-52" />
        <p className="text-xs text-gray-500 mt-1 text-center italic" data-id="element-53">
          Soms kan anderhalf uur alles veranderen in de relatie met je hond
        </p>
      </div>
      <a href="https://stresslessdogs.nl/mcc-meta-adv1" className="block bg-red-50 p-3 rounded-lg mb-6 border-2 border-red-300 hover:bg-red-100 transition-colors" onClick={openModal} target="_blank" rel="noopener noreferrer" data-id="element-54">
        <p className="text-center font-bold text-red-700" data-id="element-55">
          ⚠️ BEPERKTE PLEKKEN - Maximaal 75 per sessie ⚠️
        </p>
      </a>
      <div className="bg-gray-50 p-6 rounded-lg mb-8 border border-gray-200 hover:bg-gray-100 transition-colors" data-id="element-56">
        <div className="flex justify-between items-center mb-4" data-id="element-57">
          <div data-id="element-58">
            <h3 className="text-lg font-bold" data-id="element-59">
              Gratis webinar "Communiceren met je hond"
            </h3>
            <p className="text-gray-600 text-sm" data-id="element-60">
              Vandaag en morgen • 10:00. 13:00 of 20:00
            </p>
          </div>
          <div className="text-right" data-id="element-61">
            <span className="text-2xl font-bold text-blue-800" data-id="element-62">GRATIS</span>
            <p className="text-sm text-green-600" data-id="element-63">Geen verborgen kosten</p>
          </div>
        </div>
        <button onClick={openModal} className="w-full bg-green-600 hover:bg-green-700 text-white font-bold py-4 px-4 rounded-lg transition duration-200 mb-4 animate-pulse" data-id="element-64">
          JA, IK WIL DE WAARHEID WETEN - GRATIS AANMELDEN
        </button>
        <p className="text-center text-sm text-gray-600 mb-2" data-id="element-65">
          David L. Mech heeft zijn fout toegegeven. Het is tijd dat de rest van
          de wereld luistert.
        </p>
        <div className="flex justify-center space-x-2" data-id="element-66">
          <span className="text-yellow-500" data-id="element-67">★★★★★</span>
          <span className="text-sm text-gray-600" data-id="element-68">
            Meer dan 100.000 deelnemers in 2025
          </span>
        </div>
      </div>
      <p className="font-semibold text-blue-800 text-center mb-6" data-id="element-69">
        <span className="hover:underline cursor-pointer" onClick={openModal} data-id="element-70">
          Want soms kan 90 minuten alles veranderen.
        </span>
      </p>
    </section>;
};